export default __webpack_public_path__ + "static/media/pizza.8699527c.png";